module.exports = __webpack_public_path__ + "static/img/logo.ab05bf6a.svg";